module.exports = __webpack_public_path__ + "media/configurations/SV_P-X-X-7df3b582.png";